export const SING_IN_TEXT = 'Sign In'
export const RETURN_TO_HOMEPAGE_TEXT = 'Back to Homepage'

export const TYPES_MODULE = {
  MODAL: 'modal',
  PAGE: 'page',
} as const
